import produce from 'immer'
import cloneDeep from 'lodash/cloneDeep'
import differenceBy from 'lodash/differenceBy'
import { MenuRequestRepository, MenuRequestModel } from '@/models/MenuRequest'
import { initialState } from './index'
import { getters as accountGetters } from '@/vuex/modules/account/constants'

export default {
  async SEARCH({ commit, state, rootGetters }) {
    const systemOwner = rootGetters[accountGetters.systemOwner]
    const systemOwnerId = systemOwner.id
    const { sortBy, descending } = state.sortOptions
    const { requestStatus, keyword } = state.filter
    const { pageSize, pageNo } = state.page
    commit('SET_LOADING', true)
    const result = await MenuRequestRepository.search({
      systemOwnerId,
      requestStatus,
      keyword,
      sortBy,
      descending,
      pageSize,
      pageNo,
    })
    commit('SET_LOADING', false)

    commit('SET_SEARCH_RESULT', result)
  },
  async BULK_APPROVE({ commit }, selectedItems) {
    commit('SET_LOADING', true)
    await MenuRequestModel.bulkApprove(selectedItems)
    commit('SET_LOADING', false)
  },
  UPDATE_SORT_OPTIONS({ commit }, { sortBy, descending }) {
    commit('UPDATE_SORT_OPTIONS', { sortBy, descending })
  },
  UPDATE_REQUEST_STATUS_FILTER({ commit }, requestStatus) {
    commit('UPDATE_REQUEST_STATUS_FILTER', requestStatus)
  },
  UPDATE_KEYWORD_FILTER({ commit }, keyword) {
    commit('SET_KEYWORD_FILTER', keyword)
  },
  UPDATE_PAGE({ commit, getters }, { pageSize, pageNo }) {
    commit('SET_PAGE', { pageSize: pageSize || getters.page.pageSize, pageNo })
  },
  TOGGLE_SELECTED_ITEM({ state, commit }, item) {
    const newState = produce(cloneDeep(state), draftState => {
      const index = draftState.selectedItems.findIndex(
        selectedItem => selectedItem.id === item.id,
      )
      if (index === -1) {
        draftState.selectedItems.push(item)
      } else {
        draftState.selectedItems.splice(index, 1)
      }
    })
    commit('UPDATE_SELECTED_ITEMS', newState.selectedItems)
  },
  TOGGLE_ALL_SELECTED_ITEMS({ state, commit, getters }) {
    const newState = produce(cloneDeep(state), draftState => {
      const { selectedApprovableItems, approvableItems } = getters

      if (
        differenceBy(approvableItems, selectedApprovableItems, 'id').length ===
        0
      ) {
        draftState.selectedItems = []
      } else {
        draftState.selectedItems = [...approvableItems]
      }
    })
    commit('UPDATE_SELECTED_ITEMS', newState.selectedItems)
  },
  INIT({ commit }) {
    const state = cloneDeep(initialState)
    commit('SET_SEARCH_RESULT', state.searchResult)
    commit('SET_LOADING', state.loading)
    commit('UPDATE_SORT_OPTIONS', state.sortOptions)
    commit('UPDATE_REQUEST_STATUS_FILTER', state.filter.requestStatus)
    commit('SET_KEYWORD_FILTER', state.filter.keyword)
    commit('UPDATE_SELECTED_ITEMS', state.selectedItems)
  },
}
